import React from "react";
import { ControlLabel, FormControl, Modal, Button, Alert } from "react-bootstrap";
import ajax from "./../lib/ajax.js";
import immutable from "immutable";
import moment from "moment";
import SpecialBillFormClockTC from "./shared/specialbill-form-clocktc.jsx";
import context from "./../lib/context.js";
import { browserHistory } from "react-router";
import FreetimePicker from "./shared/free-timepicker.jsx";
import security from "../lib/security.js";
import { CLAIMS, CLAIM_ACTIONS } from "../lib/claims.js";

const FROM_MEAL_BREAK = "From Meal Break";
const TO_MEAL_BREAK = "To Meal Break";

const selectOutReason = (inReason) => {
    console.log(inReason);
    switch (inReason) {
        case FROM_MEAL_BREAK: return "From Work";
        case "To Work": return TO_MEAL_BREAK;
        default: return null;
    }
};

const selectInReason = (outReason) => {
    console.log(outReason);
    switch (outReason) {
        case TO_MEAL_BREAK: return FROM_MEAL_BREAK;
        default: return null;
    }
};

export default class TcEntryClockTc extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentTimecard: null,
            peopleId: 0,
            placementId: 0,
            offSysId: null,
            savedTimecards: [],
            showDialogPendingSubmit: false,
            placementTasks: [],
            weekDates: [],
            inReasons: [],
            outReasons: [],
            switchTaskReasons: [],
            quarterRounding: null,
            disableMealBreakRounding: false,            
            lastPunchHeader: "",
            timecardId: -1,
            inCompleteTldId: null,
            loggedWork: {
                punchReason: null,
                punchDate: null,
                taskId: "",
                specialBill: null,
            },
            alertMessages: null,
            currentTaskId: "",
            currentInCompleteId: null,
            unpairTC: null,
            unPairWeekDates: [],
            isSwitchTask: false,
            note: "",
            currentReason: "",
            currentOutreason: TO_MEAL_BREAK,
            addNextSunday: false,
        }
        this.onCloseShowPendingSubmit = this.onCloseShowPendingSubmit.bind(this);
        this.getTimeList = this.getTimeList.bind(this);
        this.onSubmitNowClick = this.onSubmitNowClick.bind(this);
        this.onNavigateToEditTC = this.onNavigateToEditTC.bind(this);
        this.onPunchInClick = this.onPunchInClick.bind(this);
        this.onPunchOutClick = this.onPunchOutClick.bind(this);
        this.createNewTimecard = this.createNewTimecard.bind(this);
        this.onPunchReasonChange = this.onPunchReasonChange.bind(this);
        this.getNoRNDTime = this.getNoRNDTime.bind(this);
        this.handleNotesChange = this.handleNotesChange.bind(this);
        this.handleTaskChange = this.handleTaskChange.bind(this);
        this._onInReasonChanged = this._onInReasonChanged.bind(this);
        this._isMealBreakRoundingDisabled = this._isMealBreakRoundingDisabled.bind(this);
    }

    onPunchReasonChange(reason) {
        const self = this;
        // if (reason === "Switch Task") {
        //     let clone = immutable.fromJS(self.state).toJS();

        //     clone.isSwitchTask = true;
        //     clone.currentTaskId = "";
        //     clone.note = "";
        //     clone.currentInCompleteId = null;

        //     self.setState(clone);
        // }
        let clone = immutable.fromJS(self.state).toJS();
        if (reason === "Switch Task") {
            clone.isSwitchTask = true;
            clone.currentTaskId = "";
            clone.note = "";
            clone.currentInCompleteId = null;
            clone.currentOutreason = TO_MEAL_BREAK;
        }
        else {
            clone.currentOutreason = reason;
        }
        clone.currentReason = clone.currentOutreason;
        self.setState(clone);

    }

    componentDidMount() {
        let self = this;
        context.message({
            show: true,
            type: "loading",
            message: "Loading. Please wait..."
        });

        ajax.vm().get('people/tc-entry-clocktc').then(res => {
            console.log("LOAD");            
            let data = res.data;
            let clone = Object.assign({}, self.state);
            clone = Object.assign(clone, data);
            clone.addNextSunday = self._shouldAddSunday(clone.currentInCompleteId, clone.loggedWork);
            console.log(clone);
            if (data.placementTasks.length < 1) {
                data.alertMessages = "Placement tasks are missing. Please contact Help Desk";
            }

            self.setState(clone);
            context.message({
                show: false,
            });
        }).catch(function (err) {
            console.error(err);
        });
    }
    onCloseShowPendingSubmit() {
        this.setState(immutable.fromJS(this.state)
            .mergeDeep({
                showDialogPendingSubmit: false,
            }).toJS());
    }
    onSubmitNowClick() {
        let self = this;
        let tid = -1;
        if (self.state.unpairTC && self.state.unpairTC.timecardId) {
            tid = self.state.unpairTC.timecardId;
        }
        else {
            if (self.state.savedTimecards.length > 0) {
                tid = self.state.savedTimecards[0].timecardId;
            }
        }

        let url = `/people/tc-entry?edit=1&tid=${tid}`;
        browserHistory.push(context.routeUrl(url));
    }

    onPunchInClick(currentWork) {
        const self = this;
        let clockTcRequestMain = immutable.fromJS(this.state).toJS();
        currentWork.specialBill = currentWork.specialBill.getSpecialBillWithRequired();
        clockTcRequestMain.currentWork = currentWork;
        context.message({
            show: true,
            type: "loading",
            message: "Logging work. Please wait..."
        });
        ajax.api()
            .post("clocktc-punchin", clockTcRequestMain)
            .then(function (res) {
                const data = res.data;
                ajax.api()
                    .get(`get-lastlogin-textheader/${self.state.placementId}/${self.state.peopleId}/${self.state.offSysId}`)
                    .then(function (r) {
                        let result = r.data;
                        context.message({
                            show: false,
                        });
                        let clone = immutable.fromJS(self.state).toJS();
                        clone.loggedWork = data.loggedWork;
                        clone.inCompleteTldId = data.inCompleteTldId;
                        clone.timecardId = data.timecardId;
                        clone.lastPunchHeader = result;
                        clone.alertMessages = null;
                        clone.currentPunchDate = data.loggedWork.punchDate;
                        clone.currentInCompleteId = data.inCompleteTldId;
                        clone.currentTaskId = data.loggedWork.taskId;
                        clone.isSwitchTask = false;
                        clone.addNextSunday = self._shouldAddSunday(clone.currentInCompleteId, clone.loggedWork);
                        clone.currentReason = null;
                        self.setState(clone);
                    });

            })
            .catch(function (err) {
                console.log(err);
                context.message({
                    show: false,
                });
                let map = immutable.fromJS(self.state);
                let data = err && err.response ? err.response.data : null;
                let errors = null;
                let errItems = [];
                if (data && data.ClassName === "ActionPortal.ValidationException") {
                    for (let key in data.Data.summary.validationResults) {
                        errItems.push((
                            <li key={key}>{data.Data.summary.validationResults[key]}</li>
                        ));
                    }
                    errors = (<ul>
                        {errItems}
                    </ul>);
                } else {
                    if (data) {
                        errors = data.exceptionMessage || data.message;
                    }
                }
                let clone = map.toJS();
                clone.alertMessages = errors;
                self.setState(clone);
                context.message({
                    show: false,
                });

            });

    }

    onPunchOutClick(currentWork) {
        const self = this;
        let clockTcRequestMain = immutable.fromJS(this.state).toJS();
        clockTcRequestMain.currentWork = currentWork;
        if (clockTcRequestMain.unpairTC && clockTcRequestMain.unpairTC.timecardId) {
            clockTcRequestMain.timecardId = clockTcRequestMain.unpairTC.timecardId;
        }
        context.message({
            show: true,
            type: "loading",
            message: "Logging work. Please wait..."
        });
        ajax.api()
            .put(`clocktc-punchout/${clockTcRequestMain.inCompleteTldId}`, clockTcRequestMain)
            .then(function (res) {
                let data = res.data;
                let date = moment().format("dddd, MMMM DD, YYYY");
                ajax.api()
                    .get(`get-lastlogin-textheader/${self.state.placementId}/${self.state.peopleId}/${self.state.offSysId}`)
                    .then(function (r) {
                        let result = r.data;
                        context.message({
                            show: false,
                        });
                        let clone = immutable.fromJS(self.state).toJS();
                        clone.loggedWork = data.loggedWork;
                        clone.currentTaskId = "";
                        clone.inCompleteTldId = data.inCompleteTldId;
                        clone.lastPunchHeader = result;
                        clone.alertMessages = null;
                        clone.currentInCompleteId = data.inCompleteTldId;
                        clone.currentPunchDate = date;
                        clone.unpairTC = null;
                        clone.note = "";
                        clone.addNextSunday = self._shouldAddSunday(clone.currentInCompleteId, clone.loggedWork);
                        clone.currentReason = null;
                        self.setState(clone);
                    });
            })
            .catch(function (err) {
                context.message({
                    show: false,
                });
                //console.log(err);
                let map = immutable.fromJS(self.state);
                map.alertMessages = null;
                let data = err && err.response ? err.response.data : null;
                let errors = null;
                let errItems = [];
                if (data && data.ClassName === "ActionPortal.ValidationException") {
                    for (let key in data.Data.summary.validationResults) {
                        errItems.push((
                            <li key={key}>{data.Data.summary.validationResults[key]}</li>
                        ));
                    }
                    errors = (<ul>
                        {errItems}
                    </ul>);
                } else {
                    if (data) {
                        errors = data.exceptionMessage || data.message;
                    }
                }
                let clone = map.toJS();
                clone.alertMessages = errors;
                self.setState(clone);
                context.message({
                    show: false,
                });

            });
    }
    handleNotesChange(evt) {
        const clone = immutable.fromJS(this.state).toJS();
        clone.note = evt.target.value;
        this.setState(clone);
    }
    handleTaskChange(evt) {
        const clone = immutable.fromJS(this.state).toJS();
        clone.currentTaskId = evt.target.value;
        this.setState(clone);
    }
    onNavigateToEditTC() {
        if (this.state.unpairTC && this.state.unpairTC.timecardId) {
            browserHistory.push(context.routeUrl(`/people/tc-entry?edit=1&tid=${this.state.unpairTC.timecardId}`));
        }
        else {
            if (this.state.timecardId > 0) {
                browserHistory.push(context.routeUrl(`/people/tc-entry?edit=1&tid=${this.state.timecardId}`));
            }
            else {
                this.setState(immutable.fromJS(this.state)
                    .mergeDeep({
                        alertMessages: "System cannot find timecard for this week ending"
                    }).toJS());
            }
        }
    }
    getTimeList() {
        console.log("getTimeList");
        let timeList = [];
        let m = moment().startOf("d");
        let now = moment();
        let selectedTime = "0:00";
        for (let i = 0; i < 96; i++) {
            let d = moment.duration(now - m).asMinutes();
            if (d >= -7 && d <= 8) {
                selectedTime = m.format("H:mm");
            }
            timeList.push(
                <option key={m.format("H:mm")} value={m.format("H:mm")}>{m.format("h:mm A")}</option>
            );
            m.add(15, "m");
        }

        return {
            list: timeList,
            selectedTime: selectedTime
        };
    }
    getNoRNDTime() {
        let now = moment();
        let result = now.format("H:mm");
        return result;
    }
    createNewTimecard() {
        const clone = immutable.fromJS(this.state).toJS();
        clone.timecardId = -1;
        this.setState(clone);
    }
    getUpairClockOutReasons() {
        //From Work
        let unpairOutReasons = [];
        unpairOutReasons.push({
            key: TO_MEAL_BREAK,
            value: TO_MEAL_BREAK
        });
        unpairOutReasons.push({
            key: "From Work",
            value: "From Work"
        });
        return unpairOutReasons;
    }

    _shouldAddSunday(currentInCompleteId, loggedWork, newReason) {
        const inReason = loggedWork ? selectInReason(loggedWork.punchReason) : "";
        console.log("_shouldAddSunday", currentInCompleteId, inReason);
        return currentInCompleteId ||
            inReason === "Switch Task" ||
            inReason === FROM_MEAL_BREAK ||
            newReason === "Switch Task" ||
            newReason === FROM_MEAL_BREAK;
    }

    _normalizeDate(d) {
        return moment(d).format("YYYY-MM-DDT00:00:00");
    }

    _onInReasonChanged(evt) {
        this.setState({
            addNextSunday: this._shouldAddSunday(this.state.currentInCompleteId, this.state.loggedWork, evt.target.value),
            currentReason: evt.target.value
        });
    }

    _isMealBreakRoundingDisabled(reason) {
        return this.state.disableMealBreakRounding && (reason === FROM_MEAL_BREAK || reason === TO_MEAL_BREAK);
    }

    render() {
        let self = this;
        const timeList = this.getTimeList();
        const inputs = {};
        const loggedWork = self.state.loggedWork;
        const noRNDTime = this.getNoRNDTime();

        /*Error section*/
        let errorLogList = null;
        if (self.state.alertMessages) {
            errorLogList = (<Alert bsStyle="danger">{self.state.alertMessages}</Alert>)
        }

        /*Enable create timecard link when the TC statuis is approved && if TC status is approved then disable page*/

        const currentTc = this.state.currentTimecard;
        let shouldControlsDisable = false;       

        if (!(self.state.unpairTC && self.state.unpairTC.timecardId)) {
            if (currentTc && currentTc.statusCode.toLowerCase() != "saved" && self.state.timecardId === currentTc.timecardId) {
                let createTcLink = null;
                shouldControlsDisable = true;
                if (currentTc.statusCode.toLowerCase() === "approved" || currentTc.statusCode.toLocaleLowerCase() === "processed") {
                    createTcLink = (<a href="#" onClick={this.createNewTimecard}>Please click this link to create new time card for this weekend {moment(currentTc.weekEnding).format("MM/DD/YYYY")}</a>);
                }
                errorLogList = <Alert bsStyle="danger">Timecard for the weekend {moment(currentTc.weekEnding).format("MM/DD/YYYY")} has been {currentTc.statusCode.toLowerCase()} already! {createTcLink}</Alert>;
            }
        }
        
        /*Clock In/Out Reasons---Manipulation on switch task*/
        let reasons = null;
        let selectedReason = "";
        if (this.state.currentInCompleteId) {
            //defaultValue={self.state.outReasons[0]}
            selectedReason = selectOutReason(loggedWork.punchReason) || self.state.currentOutreason;
            if (self.state.unpairTC && self.state.unpairTC.timecardId) {
                let unpairOutReasonsList = this.getUpairClockOutReasons();
                
                reasons = <FormControl key={`_reasonOut${self.state.outReasons.length}`} componentClass="select" inputRef={node => inputs.punchReason = node}
                    onChange={evt => this.setState({ currentReason: evt.target.value })}
                    defaultValue={selectedReason}>
                    {unpairOutReasonsList.map(r => <option key={r.value} value={r.value}>{r.value}</option>)}
                </FormControl>
            }
            else {
                reasons = <FormControl key={`_reasonOut${self.state.outReasons.length}`} componentClass="select" inputRef={node => inputs.punchReason = node} disabled={shouldControlsDisable} onChange={
                    (evt) => {
                        if (evt.target.value === "Switch Task") {
                            inputs.specialBill.updateTaskId("");
                        }
                        this.onPunchReasonChange(evt.target.value);
                    }} defaultValue={selectedReason}>
                    {self.state.outReasons.map(r => <option key={r.value} value={r.value}>{r.value}</option>)}</FormControl>
            }
        }
        else {
            selectedReason = self.state.weekDates.indexOf(self._normalizeDate(loggedWork.punchDate)) > -1 ? selectInReason(loggedWork.punchReason) : "To Work";
            if (self.state.isSwitchTask) {
                reasons = <FormControl key={`_reasonSwitch${self.state.switchTaskReasons.length}`} componentClass="select" 
                    inputRef={node => inputs.punchReason = node} disabled={shouldControlsDisable || self.state.isSwitchTask}
                    onChange={evt => {
                        this.setState({ currentReason: evt.target.value });                        
                    }}>
                    {self.state.switchTaskReasons.map(r => <option key={r.value} value={r.value}>{r.value}</option>)}
                    </FormControl>
            }
            else {
                reasons = <FormControl key={`_reasonIn${self.state.inReasons.length}`} componentClass="select"
                    inputRef={node => inputs.punchReason = node} disabled={shouldControlsDisable}
                    onChange={(evt) => {                        
                        this._onInReasonChanged(evt);
                    }}
                    defaultValue={selectedReason}>
                    {self.state.inReasons.map(r => <option key={r.value} value={r.value}>{r.value}</option>)}
                </FormControl>
            }
        }        

        selectedReason = this.state.currentReason || selectedReason;

        /*clock time as per the rounding rule from placement*/
        let clockTime = null;
        if (self.state.quarterRounding && !this._isMealBreakRoundingDisabled(selectedReason)) {
            clockTime = <FormControl componentClass="select" defaultValue={function () { if (inputs.punchTime) inputs.punchTime.value = timeList.selectedTime; return timeList.selectedTime; }()}
                inputRef={node => inputs.punchTime = node} disabled={shouldControlsDisable}>{immutable.fromJS(timeList.list).toJS()}</FormControl>
        }
        else {
            clockTime = <FreetimePicker 
                ref={node => inputs.punchTime = node}
                // ref="punchTime" 
                disabled={shouldControlsDisable} 
                // onChange={() => inputs.punchTime = self.refs.punchTime.getValue()}
                time={function () { inputs.punchTime = noRNDTime; return noRNDTime; }()} />
        }

        /*Modal section to display past saved timecards that needs to be submitted*/
        let dialogSubmitPending = null;
        if (self.state.showDialogPendingSubmit) {
            dialogSubmitPending =
                <Modal show={self.state.showDialogPendingSubmit} onHide={this.onCloseShowPendingSubmit}>
                    <Modal.Header closeButton className="ap-bkg-color-gray">
                        <Modal.Title>Alert</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="container-fluid">
                            <div className="col-md-12 col-xs-12 text-center">
                                You have a Time Sheet that needs to be submitted.
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-6 col-xs-6 text-center">
                                    <Button onClick={this.onSubmitNowClick}>Submit Now</Button>
                                </div>
                                <div className="col-md-6 col-xs-6 text-center">
                                    <Button onClick={this.onCloseShowPendingSubmit}>Submit Later</Button>
                                </div>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
        }


        /*Limit WeekDates Dropdown Selection if unpair exists in timecard*/
        let WeekDaysDropDown = [];
        let lastDay = null;

        const currentDate = moment().format("dddd, MMMM DD, YYYY");
        const selectedDate = !(self.state.unpairTC && self.state.unpairTC.timecardId) ? currentDate : null;

        if (self.state.unpairTC && self.state.unpairTC.timecardId) {
            /*Map from unpairweekdates array*/
            WeekDaysDropDown = self.state.unPairWeekDates.map(wd => {
                const v = moment(wd).format("dddd, MMMM DD, YYYY");
                return <option key={wd} value={v} selected={v === selectedDate}>{v}</option>;
            })
            lastDay = moment(self.state.unPairWeekDates[self.state.unPairWeekDates.length - 1]);
        }
        else {
            /*Map from regular weekdates array*/
            WeekDaysDropDown = self.state.weekDates.map(wd => {
                const v = moment(wd).format("dddd, MMMM DD, YYYY");
                return <option key={wd} value={v} selected={v === selectedDate}>{v}</option>;
            })
            lastDay = moment(self.state.weekDates[self.state.weekDates.length - 1]);
        }

        if (self.state.addNextSunday) {
            lastDay.add(1, "day");
            const v = lastDay.format("dddd, MMMM DD, YYYY");
            WeekDaysDropDown.push(<option key={lastDay.format("YYYY-MM-DDT00:00:00")} value={v} selected={v === selectedDate}>{v}</option>);
        }

        return (
            <div className="ap-form-container">
                <div className="container">
                    <div className="row">
                        <div className="col-md-10 col-md-offset-1 col-xs-12">
                            <div className="container-fluid">
                                <div className="row">
                                    {dialogSubmitPending}
                                </div>
                                <div className="row">
                                    <div className="col-md-12 text-center"> <h2><b>Clock In/Out</b></h2></div>
                                    <div className="col-md-12">
                                        {errorLogList}
                                    </div>
                                    <div className="col-md-12 text-center">
                                        <div>
                                            <b> {self.state.lastPunchHeader} </b> <br /><br />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-2 col-lg-2 text-right hidden-sm hidden-xs">
                                        <ControlLabel>Clock Time</ControlLabel>
                                    </div>
                                    <div className="col-xs-12 col-sm-12 hidden-md hidden-lg">
                                        <ControlLabel>Clock Time</ControlLabel>
                                    </div>
                                    <div className="col-md-4 col-xs-12">
                                        {clockTime}
                                    </div>
                                    <div className="col-md-6 col-xs-12">
                                        <FormControl componentClass="select" inputRef={node => inputs.currentPunchDate = node}
                                            defaultValue={!(self.state.unpairTC && self.state.unpairTC.timecardId) ? currentDate : null}
                                            disabled={shouldControlsDisable}>
                                            {WeekDaysDropDown}
                                        </FormControl>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-2 col-lg-2 text-right hidden-sm hidden-xs">
                                        <ControlLabel>{this.state.currentInCompleteId ? "Clock Out" : "Clock In"}</ControlLabel>
                                    </div>
                                    <div className="col-xs-12 col-sm-12 hidden-md hidden-lg">
                                        <ControlLabel>{this.state.currentInCompleteId ? "Clock Out" : "Clock In"}</ControlLabel>
                                    </div>
                                    <div className="col-md-10 col-xs-12">
                                        {reasons}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-2 col-lg-2 text-right hidden-sm hidden-xs">
                                        <ControlLabel>Task <span className="ap-color-red">*</span></ControlLabel>
                                    </div>
                                    <div className="col-xs-12 col-sm-12 hidden-md hidden-lg">
                                        <ControlLabel>Task <span className="ap-color-red">*</span></ControlLabel>
                                    </div>
                                    <div className="col-md-10 col-xs-12">
                                        <FormControl componentClass="select"
                                            onChange={(evt) => {
                                                inputs.specialBill.updateTaskId(evt.target.value);
                                                this.handleTaskChange(evt);
                                            }}
                                            inputRef={node => inputs.taskId = node} value={self.state.currentTaskId} disabled={self.state.currentInCompleteId || shouldControlsDisable ? true : false}>
                                            <option key="" value="" >Please select...</option>
                                            {self.state.placementTasks.map(pt => <option key={pt.placementTaskId} value={pt.placementTaskId}>{pt.taskValue}</option>)}
                                        </FormControl>
                                    </div>
                                    <div className="col-md-2 col-lg-2 text-right hidden-sm hidden-xs">
                                        <ControlLabel>Note</ControlLabel>
                                    </div>
                                    <div className="col-xs-12 col-sm-12 hidden-md hidden-lg">
                                        <ControlLabel>Note</ControlLabel>
                                    </div>
                                    <div className="col-sm-12 col-md-10 col-xs-12">
                                        <FormControl componentClass="textarea" placeholder="Note" rows="2" value={self.state.note} onChange={this.handleNotesChange}
                                            disabled={self.state.currentInCompleteId || shouldControlsDisable ? true : false} />
                                    </div>
                                </div>
                                <div className="row">
                                    <SpecialBillFormClockTC ref={node => inputs.specialBill = node} specialBill={this.state.currentInCompleteId ? self.state.loggedWork.specialBill : null} taskId={self.state.loggedWork.taskId} shouldDisable={self.state.currentInCompleteId && self.state.currentInCompleteId > 0 ? "yes" : "no"} />
                                </div>
                                <div className="row">

                                    <div className="col-md-2 col-md-offset-4 text-right col-xs-6">
                                        <button type="button" onClick={() => {
                                            this.onPunchInClick({
                                                punchDate: inputs.currentPunchDate.value,
                                                punchTime: inputs.punchTime.value || inputs.punchTime.getValue(),
                                                punchReason: inputs.punchReason.value,
                                                taskId: inputs.taskId.value,
                                                specialBill: inputs.specialBill,
                                            });
                                        }} className={self.state.currentInCompleteId || shouldControlsDisable ? "ap-punch-button-disable" : "btn-info ap-punch-button"} disabled={self.state.currentInCompleteId ? true : (false || shouldControlsDisable)}>
                                            IN
                                        </button>
                                    </div>
                                    <div className="col-md-2 text-left col-xs-6">
                                        <button type="button" onClick={() => {
                                            this.onPunchOutClick({
                                                punchDate: inputs.currentPunchDate.value,
                                                punchTime: inputs.punchTime.value || inputs.punchTime.getValue(),
                                                punchReason: inputs.punchReason.value,
                                                taskId: loggedWork.taskId,
                                                specialBill: loggedWork.specialBill,
                                            });
                                        }} className={self.state.currentInCompleteId ? "btn-info ap-punch-button" : "ap-punch-button-disable"} disabled={self.state.currentInCompleteId ? (false || shouldControlsDisable) : true}>
                                            OUT
                                        </button>
                                    </div>

                                </div>
                                <div className="row">
                                    <br />
                                    <div className="ap-edit-submit-TC">
                                        <button onClick={this.onNavigateToEditTC} className="btn btn-info" disabled={shouldControlsDisable}>Edit/Submit Timecard</ button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        );

    }
}




